import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  loading$ = new Subject<boolean>();
  isManualLoad$ = new Subject<boolean>();
  private readonly manualOwners = new Set<object>();
  private readonly automaticOwners = new Set<object>();
  private readonly legacyLoadingOwner = {};
  private readonly legacyManualOwner = {};
  private loading = false;
  private manual = false;

  /** Each operation releases only its own loading scope, at most once. */
  acquire(manual = false): () => void {
    const owner = {};
    const owners = manual ? this.manualOwners : this.automaticOwners;
    owners.add(owner);
    this.publish();
    return () => {
      if (owners.delete(owner)) this.publish();
    };
  }

  // Named owners also make existing start/stop pairs safe against other callers.
  startLoading(owner: object = this.legacyLoadingOwner): void {
    this.automaticOwners.add(owner);
    this.publish();
  }

  stopLoading(owner: object = this.legacyLoadingOwner): void {
    this.automaticOwners.delete(owner);
    this.publish();
  }

  startManualLoad(owner: object = this.legacyManualOwner): void {
    this.manualOwners.add(owner);
    this.publish();
  }

  stopManualLoad(owner: object = this.legacyManualOwner): void {
    this.manualOwners.delete(owner);
    this.publish();
  }

  private publish(): void {
    const manual = this.manualOwners.size > 0;
    const loading = manual || this.automaticOwners.size > 0;
    if (manual !== this.manual) {
      this.manual = manual;
      this.isManualLoad$.next(manual);
    }
    if (loading !== this.loading) {
      this.loading = loading;
      this.loading$.next(loading);
      if (typeof document !== 'undefined') {
        document.getElementById('loader-wrapper')?.classList.toggle('hidden', !loading);
      }
    }
  }
}
